import { toast as sonner } from 'sonner';
import { ApiError, errorMessage } from '../api/client.js';

type Tone = 'ok' | 'error' | 'info';
export const TOAST_MS = 4000;

/** Show a toast. Law codes, when present on an error, go in the small description line only. */
export function notify(text: string, tone: Tone = 'info', description?: string): void {
  const opts = { description, duration: TOAST_MS };
  if (tone === 'ok') sonner.success(text, opts);
  else if (tone === 'error') sonner.error(text, { ...opts, duration: 6000 });
  else sonner(text, opts);
}

/** Toast for a caught error; never swallow, always tell the user. */
export function notifyError(e: unknown): void {
  const law = e instanceof ApiError ? e.law : undefined;
  notify(errorMessage(e), 'error', law ? `Selling rule ${law}` : undefined);
}

/** Back-compat hook used by ported pages. */
export function useToast() {
  return notify;
}
